import type {ReactElement} from 'react';
import React from 'react';
import type {ChatHistoryListItemOptionsPopupProps} from './chat-history-list-item-options-popup.types';
import styles from './chat-history-list-item-options-popup.module.scss';
import {ColorTypes, ControlledListItemType7} from '@Components/controlled-list/components/controlled-list-item-type-7';

export function ChatHistoryListItemOptionsPopup({onRename, onDelete}: ChatHistoryListItemOptionsPopupProps): ReactElement {
  return (
    <ul className={styles.container}>
      <ControlledListItemType7 id={'rename'} text={window.i18next.t('pmwjs_rename')} className={'radius-8'} icon={'icon-pencil'} onClick={onRename} />
      <ControlledListItemType7 id={'delete'} text={window.i18next.t('pmwjs_delete')} className={'radius-8'} icon="icon-delete" color={ColorTypes.danger} onClick={onDelete} />
    </ul>
  );
}
